@if (instantArticle) {
  <div class="dropdown-menu col-md-12" [ngClass]="display ? '' : 'hidden'"
    [style.display]="display ? 'block' : 'none'">
    @if (display) {
      <app-article-card [article]="instantArticle" [showBomButton]="showBom" [framenumber]="searchterm" [showAddButtons]="true" [useLazyLoad]="false"
      (showArticleDetails)="showArticleDetails($event)" [autoShowDetails]="true" [showModelYear]="true"></app-article-card>
    }
  </div>
}
